export const UPDATE_PRODUCTS_CURRENCY =  'UPDATE_PRODUCTS_CURRENCY';